import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { RouteReuseStrategy } from '@angular/router';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { HomeComponent } from './home/home.component';
import { DemoComponent } from './demo/demo.component';
import { JobExperienceComponent } from './job-experience/job-experience.component';
import { TranslatePipe } from './i18n/translate.pipe';
import { CookiePolicyComponent } from './cookie-policy/cookie-policy.component';
import { LegalNoticeComponent } from './legal-notice/legal-notice.component';

@NgModule({
  declarations: [
      AppComponent,
      HomeComponent,
      DemoComponent,
      JobExperienceComponent,
      CookiePolicyComponent,
      LegalNoticeComponent,
      TranslatePipe
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    IonicModule.forRoot({})
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
